import * as DataSource from './server';
// import * as DataSource from './Dummy'
// import { ConsoleLog } from "../../../../Common/CommonFunction/ConsoleHelper";

export function GetCycleDefaultValue() {
  return DataSource.GetCycleParam2().then(
    (response) =>
      // ConsoleLog("2. server response:", response);
      response,
  );
}

export function GetCycleDefaultValue2() {
  return DataSource.GetCycleParam2().then((response) => response);
}
